import { PackageMonitoringResponseEntity } from '@/features/trackOrderTwo/domain/entities/packageEntites/PackageMonitoringResponseEntity'
import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { PackageMonitoringModel } from './PackageMonitoringModel'
import type { GetMonitoringPackagesResponseAdmin } from '@/backend/market'

export class PackageMonitoringResponseModel extends PackageMonitoringResponseEntity {
  constructor(dataDto: GetMonitoringPackagesResponseAdmin) {
    super()
    const packageMonitoringModels = dataDto.packages?.map(
      (packageDto) => new PackageMonitoringModel(packageDto)
    )
    mapEntityProperties<PackageMonitoringResponseModel>(this, dataDto, {
      map: {
        packages: packageMonitoringModels
      }
    })
  }
}
